import React from "react";
import { Box, Typography } from "@mui/material";
import THEME from "../../constants/theme";

export default function BrandLogo({ light = false, compact = false, sx = {} }) {
  return (
    <Box role="img" aria-label={THEME.manifest.name} sx={{ display: "inline-flex", alignItems: "center", gap: 1.25, flexShrink: 0, ...sx }}>
      <Box component="img" src="/logo/esainex-lms-192.png" alt="" sx={{ width: compact ? 36 : 46, height: compact ? 36 : 46, borderRadius: "12px", backgroundColor: "#fff", objectFit: "contain" }} />
      <Box sx={compact ? { "@media (max-width: 380px)": { display: "none" } } : {}}>
        <Typography component="span" sx={{ display: "block", color: light ? "#fff" : THEME.colors.dark, fontSize: 22, fontWeight: 800, letterSpacing: "-0.8px", lineHeight: 1.1 }}>
          Esai<Box component="span" sx={{ color: light ? "#74EEFA" : THEME.colors.primary }}>Nex</Box>
          <Box component="span" sx={{ fontSize: 12, fontWeight: 700, letterSpacing: "1px", ml: 0.8 }}>LMS</Box>
        </Typography>
        <Typography component="span" sx={{ display: "block", mt: 0.45, fontSize: 9, fontWeight: 600, letterSpacing: "1.5px", color: light ? "#C9DFF7" : THEME.colors.textSecondary }}>LEARN. GROW. ACHIEVE.</Typography>
      </Box>
    </Box>
  );
}
